import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { NOTES_INITIAL_STATE } from './constants';
import {
  Note,
  NotesState,
  ThreadErrorPayload,
  ThreadLoadingPayload,
  ThreadNotesPayload,
} from './types';

export const notesSlice = createSlice({
  name: 'notes',
  initialState: NOTES_INITIAL_STATE,
  reducers: {
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    setLoadingMoreError(state, action: PayloadAction<string>) {
      state.loadMoreError = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setLoadingMore(state, action: PayloadAction<boolean>) {
      state.loadingMore = action.payload;
    },
    setThreadError(state, action: PayloadAction<ThreadErrorPayload>) {
      state.threadError[action.payload.parentKey] = action.payload.error;
    },
    setThreadLoading(state, action: PayloadAction<ThreadLoadingPayload>) {
      state.threadLoading[action.payload.parentKey] = action.payload.loading;
    },
    setNotes(state, action: PayloadAction<Note[]>) {
      const incomingNotes = action.payload || [];
      state.notes = incomingNotes;
    },
    pushMoreNotes(state, action: PayloadAction<Note[]>) {
      const incomingNotes = action.payload || [];
      state.notes.push(...incomingNotes);
    },
    setThreadNotes(state, action: PayloadAction<ThreadNotesPayload>) {
      const { parentKey, notes = [] } = action.payload;
      state.threadNotes[parentKey] = notes;
    },
    pushMoreThreadNotes(state, action: PayloadAction<ThreadNotesPayload>) {
      const { parentKey, notes = [] } = action.payload;

      state.threadNotes[parentKey].push(...notes);
    },
    setUsers(state, action: PayloadAction<NotesState['users']>) {
      state.users = action.payload;
    },
    setIsParentEditorActive(state, action: PayloadAction<boolean>) {
      state.isParentEditorActive = action.payload;
    },
    clearNotes(state) {
      state.notes = [];
      state.threadNotes = {};
      state.isParentEditorActive = true;
    },
  },
});

export const {
  clearNotes,
  setError,
  setLoading,
  setThreadError,
  setThreadLoading,
  setNotes,
  pushMoreNotes,
  pushMoreThreadNotes,
  setThreadNotes,
  setUsers,
  setLoadingMore,
  setLoadingMoreError,
  setIsParentEditorActive,
} = notesSlice.actions;

const reducer = { notes: notesSlice.reducer };

export default reducer;
